import { Module } from 'vuex';

import { AuthState } from './types';
import { StoreState } from '@/types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state: AuthState = {
  sessionTimeoutUnix: 0,
  state: '',

  account: null,
  token: null,
};

const module: Module<AuthState, StoreState> = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};

export default module;
